export const useFocusableElements =
  (root: HTMLElement | Document | null = document) =>
  () =>
    root?.querySelectorAll<HTMLElement>(
      `button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), video`
    );
